import { AxiosError } from 'axios';

export const downloadApp = async (data: Blob) => {
    try {
        // const response = await axios.get('http://192.168.103.30:7201/launcherdownload', {responseType:'blob'})
        // const data = response.data as Blob;

        const url = window.URL.createObjectURL(new Blob([data]));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'sLauncher.exe';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        if (err instanceof AxiosError) {
            console.log('Error: ', err.message);
        }
    }
};
